export default {
  header: "List of Dog",
  page: "Dog",
};
